import { translate } from '@/domains/core/localization/translate';
export const {
  january,
  february,
  march,
  april,
  may,
  june,
  july,
  august,
  september,
  october,
  november,
  december
} = translate({
  "april": "April",
  "august": "August",
  "december": "December",
  "february": "February",
  "january": "January",
  "july": "July",
  "june": "June",
  "march": "March",
  "may": "May",
  "november": "November",
  "october": "October",
  "september": "September"
});
export const months = [january, february, march, april, may, june, july, august, september, october, november, december];